(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'Principal', 'entity', 'User', 'Timecard', 'MessageService', '$timeout', '$rootScope'];

    function UserManagementDeleteController ($uibModalInstance, Principal, entity, User, Timecard, MessageService, $timeout, $rootScope) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    MessageService.success("global.messages.info.delete");
                    $uibModalInstance.close(true);
                    $timeout(function(){$rootScope.$broadcast('messageChanged');}, 500);
                    //当前登录用户的权限包含打卡时,则将timeCare表和history表和salary表中的所有打卡信息的deleted设成1
                    Principal.identity().then(function(account) {
                        if(account.authorities.indexOf('ROLE_TIMECARD') !== -1 ||
                            account.authorities.indexOf('ROLE_ADMIN') !== -1) {
                            Timecard.deleteTimeCard({userId: vm.user.id}, function (){
                            });
                        }
                    });
                });
        }
    }
})();
